import React from 'react';
import './payment-status-chips.scss';
interface PaymentStatusChipsProps {
  selectedStatus: string;
  statusChips: {
    label: string;
    value: string;
    onClick: () => void;
  }[];
  appliedFilters?: string[];
}
export const PaymentStatusChips: React.FC<PaymentStatusChipsProps> = ({
  selectedStatus,
  statusChips,
  appliedFilters,
}) => {
  return (
    <div className="payment-status-chips">
      {appliedFilters?.map((chip) => (
        <div
          key={chip}
          className={`payment-status-chips-chip active`}
          onClick={() => {}}
        >
          {chip}
        </div>
      ))}
      {appliedFilters?.length > 0 && (
        <div className="chips-vertical-divider"></div>
      )}
      {statusChips.map((chip) => (
        <div
          key={chip.value}
          className={`payment-status-chips-chip ${
            selectedStatus === chip.value ? 'active' : ''
          }`}
          onClick={chip.onClick}
        >
          {chip.label}
        </div>
      ))}
    </div>
  );
};
